import { ConfigProvider, Flex, Select, Spin, Tabs, Typography } from 'antd';
import React, { useState, useEffect } from 'react';
import Plates from '../../Components/Plates/plates';
import MenuCalendar from '../../Components/Menu/MenuCalendar';
import { isMobile } from 'react-device-detect';
export default function NewDailyPlanningPage() {
    const [selectedDay, setSelectedDay] = useState('Segunda');
    const [Day, setDay] = useState(1);
    const [isLoading, setIsLoading] = useState(false);

    const handleSegmentedChange = (option) => {
        setIsLoading(true);
        const numericDay = {
            Segunda: 1,
            Terça: 2,
            Quarta: 3,
            Quinta: 4,
            Sexta: 5,
            Sábado: 6,
            Domingo: 7,
        }[option];

        if (numericDay !== undefined) {
            setSelectedDay(option);
            setDay(numericDay);
            setIsLoading(false);
        }
    };

    const items = Object.keys({
        Segunda: 1,
        Terça: 2,
        Quarta: 3,
        Quinta: 4,
        Sexta: 5,
        Sábado: 6,
        Domingo: 7,
    }).map((day) => ({
        key: day,
        label: day,
        children: isLoading ? <Spin size="large" /> : <MenuCalendar selectedDay={selectedDay} Day={Day} setLoading={setIsLoading} />,
    }));

    return (
        <Flex vertical justify='center' style={{
            width: "100%",
            marginTop: "1rem",
        }}>
            {isMobile ? (
                <Flex vertical align='center' justify='center' style={{
                    width: "100%"
                }}>
                    <Typography.Title level={2}>
                        Planeamento de diárias
                    </Typography.Title>
                    <Typography.Title level={5}>
                        Selecione o dia da semana
                    </Typography.Title>
                    <Select
                        defaultValue={items[0].key}
                        onChange={handleSegmentedChange}
                        style={{
                            width: "90%",
                        }}
                    >
                        {items.map((item) => (
                            <Select.Option value={item.key} key={item.key}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                    <Flex align='center' justify='center' style={{
                        marginTop: "1rem",
                    }}>
                        {isLoading ? <Spin size="large" /> : <MenuCalendar selectedDay={selectedDay} Day={Day} setLoading={setIsLoading} />}
                    </Flex>
                </Flex>

            ) : (
                <Flex align='center' justify='center' style={{
                    marginTop: "1rem",
                }} vertical gap={10}>
                    <Typography.Title level={2}>
                        Planeamento de diárias
                    </Typography.Title>
                    <Typography.Title level={4}>
                        Selecione o dia da semana
                    </Typography.Title>
                    <Tabs
                        size="large"
                        defaultActiveKey="Segunda"
                        tabPosition={"left"}
                        tabBarGutter={40}
                        tabBarStyle={{
                            margin: "auto",
                            justifyContent: "space-between",
                            alignItems: "stretch",
                        }}
                        items={items}
                        onChange={handleSegmentedChange}
                        style={{
                            width: "100%",
                        }}
                    />
                </Flex>
            )
            }
        </Flex >
    );
}
